<div class="self-assessment" *ngIf="requirementTypes.length > 0">
  <ng-container *ngFor="let reqType of requirementTypes">
    <ng-container *ngIf="reqType.selfAssessmentSlide === activeSlide">
      <div class="self-assessment__option" *ngFor="let requirement of reqType.requirements">
        <brt-icon-checkbox (state-changed)="toggleOption(reqType.bicId, requirement.id)"
                           [data]="{id: requirement.id, title: requirement.requirementName,
                                    selected: isSelected(reqType.bicId, requirement.id),
                                    icon: getIconById(requirement.id), hint: requirement.description}">
        </brt-icon-checkbox>
      </div>
    </ng-container>
  </ng-container>
</div>

